import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFunnelGoalsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetFunnelGoalsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly analyticGoals: ReadonlyArray<{ readonly __typename?: 'YalperAnalyticGoal', readonly id: number, readonly isEcomm: boolean, readonly name: string, readonly counterId: number, readonly counterName: string }> } | null } | null };

export type GetFunnelSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetFunnelSettingsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly funnelSettings: { readonly __typename?: 'YalperFunnelSettings', readonly attributionModel: Types.YalperAnalyticAttributionModelEnum, readonly goals: ReadonlyArray<{ readonly __typename?: 'YalperFunnelGoal', readonly id: number, readonly name: string, readonly counterId: number, readonly counterName: string }> } } | null } | null };


export const GetFunnelGoalsDocument = gql`
    query GetFunnelGoals($companyId: ID!) {
  currentUser {
    currentCompany {
      analyticGoals(companyId: $companyId) {
        id
        isEcomm
        name
        counterId
        counterName
      }
    }
  }
}
    `;

/**
 * __useGetFunnelGoalsQuery__
 *
 * To run a query within a React component, call `useGetFunnelGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelGoalsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetFunnelGoalsQuery(baseOptions: Apollo.QueryHookOptions<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables> & ({ variables: GetFunnelGoalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>(GetFunnelGoalsDocument, options);
      }
export function useGetFunnelGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>(GetFunnelGoalsDocument, options);
        }
export function useGetFunnelGoalsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>(GetFunnelGoalsDocument, options);
        }
export type GetFunnelGoalsQueryHookResult = ReturnType<typeof useGetFunnelGoalsQuery>;
export type GetFunnelGoalsLazyQueryHookResult = ReturnType<typeof useGetFunnelGoalsLazyQuery>;
export type GetFunnelGoalsSuspenseQueryHookResult = ReturnType<typeof useGetFunnelGoalsSuspenseQuery>;
export type GetFunnelGoalsQueryResult = Apollo.QueryResult<GetFunnelGoalsQueryPage, GetFunnelGoalsQueryVariables>;
export const GetFunnelSettingsDocument = gql`
    query GetFunnelSettings {
  currentUser {
    currentCompany {
      funnelSettings {
        goals {
          id
          name
          counterId
          counterName
        }
        attributionModel
      }
    }
  }
}
    `;

/**
 * __useGetFunnelSettingsQuery__
 *
 * To run a query within a React component, call `useGetFunnelSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFunnelSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFunnelSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFunnelSettingsQuery(baseOptions?: Apollo.QueryHookOptions<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>(GetFunnelSettingsDocument, options);
      }
export function useGetFunnelSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>(GetFunnelSettingsDocument, options);
        }
export function useGetFunnelSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>(GetFunnelSettingsDocument, options);
        }
export type GetFunnelSettingsQueryHookResult = ReturnType<typeof useGetFunnelSettingsQuery>;
export type GetFunnelSettingsLazyQueryHookResult = ReturnType<typeof useGetFunnelSettingsLazyQuery>;
export type GetFunnelSettingsSuspenseQueryHookResult = ReturnType<typeof useGetFunnelSettingsSuspenseQuery>;
export type GetFunnelSettingsQueryResult = Apollo.QueryResult<GetFunnelSettingsQueryPage, GetFunnelSettingsQueryVariables>;